<template>
  <div class="page presentation-screen">
    <Transition>
      <component
        v-if="section && !pathway"
        :key="section.index"
        :is="section.type"
        :section="section"
        :idx="section.index.toString()"
        @action="onAction"
      />
    </Transition>

    <Transition>
      <PathwayScreen
        v-if="pathway"
        :key="pathway.index"
        ref="pathway"
        :pathway="pathway"
        @action="onAction"
      />
    </Transition>
    
    <div
      :class="[ 'button', 'button-navigation', 'button-next', { active: buttonNextActive && showButton } ]"
      @click.prevent="onClick"
    ></div>
  </div>
</template>
  
<script>
import ContentSection from '../sections/ContentSection.vue'
import DetailSection from '../sections/DetailSection.vue'
import PathwayScreen from './PathwayScreen.vue'

export default {
  name: 'PresentationScreen',
  components: {
    ContentSection,
    DetailSection,
    PathwayScreen,
  },
  data() {
    return {
      section: null,
      pathway: null,
      buttonNextActive: false,

      eventHandlers: {
        'activateButton': this.activateButton,
        'setNextButtonState': this.setNextButtonState,
        'followPathway': this.followPathway,
        'clearPathway': this.clearPathway,
        'gotoSection': this.gotoSection,
      },
    }
  },
  computed: {
    showButton() {
      return this.section.index < this.$store.getters.sectionCount - 1;
    },
  },
  methods: {
    nextSection() {
      this.buttonNextActive = false;
      this.$store.dispatch('NextSection');
      this.section = this.$store.getters.currentSection;
    },

    onAction(event) {
      if (event.type in this.eventHandlers) {
        return this.eventHandlers[event.type](event);
      }
      this.$emit('action', event);
    },
    activateButton() {
      if (this.section.autoplay) {
        this.nextSection();
      } else {
        this.buttonNextActive = true;
      }
    },
    setNextButtonState(event) {
      this.buttonNextActive = event.data;
    },
    followPathway(event) {
      this.$store.commit('SetCurrentPathway', event.data);
      this.pathway = this.$store.getters.currentPathway;
    },
    clearPathway() {
      this.$emit('action', { type: 'updateHeader', data: this.section['header-color'] });
      this.$store.commit('SetCurrentPathway', -1);
      this.$store.commit('SetReferenceGroup', 0);
      this.pathway = null;
    },
    gotoSection(event) {
      this.clearPathway();
      this.$store.commit('SetSection', event.data);
      this.section = this.$store.getters.currentSection;
    },
    setSection(event) {
      this.clearPathway();
      this.$store.commit('SetSection', event.data);
      this.section = this.$store.getters.currentSection;
    },
    onClick() {
      if (this.buttonNextActive) {
        this.nextSection();
      }
    },

    reset() {
      this.$emit('action', { type: 'updateHeader', data: '' });
      this.$store.commit('SetSection', 0);
      this.clearPathway();
    },
    pauseVideo() {
      if (this.pathway) {
        this.$refs['pathway'].pause();
      }
    },
    resumeVideo() {
      if (this.pathway) {
        this.$refs['pathway'].resume();
      }
    },
  },
  created() {
    this.section = this.$store.getters.currentSection;
  },
}
</script>
  